import * as React from 'react';

// sync redux for legacy code
import { useDispatch } from 'react-redux';
import { setDispensary } from '../actions/cartActions';

import { fetchDispensary } from '../dispensaries/dispensary-utils';
import { trackEvent } from '../analytics/tracking';
import PropTypes from 'prop-types';

// In case we have no valid id
const DISPENSARY_NOT_AVAILABLE = -1;

export const DispensaryContext = React.createContext();

const DispensaryProvider = ({children}) => {
  
  const [dispensary, setLocalDispensary] = React.useState();
  const [loading, setLoading] = React.useState();
  const [currentDispensaryId, setCurrentDispensaryId] = React.useState();
  // Handle missing/disabled dispensaries
  const [dispensaryNotFound, setDispensaryNotFound] = React.useState(false);
  
  const dispatch = useDispatch(); 

  const dispensaryCallback = React.useCallback((response) => {   
    if (response.id) {
      console.log('Dispensary Provider: SETTING');
      setLocalDispensary(response);
      setCurrentDispensaryId(response.id);
      dispatch(setDispensary(response.id));
      setDispensaryNotFound(false);
    } else if (response.status === 404) {
      console.log('Dispensary Not Found');
      setDispensaryNotFound(true);
      setCurrentDispensaryId(DISPENSARY_NOT_AVAILABLE);
      trackEvent(`dispensary_not_found_${currentDispensaryId}`);
    } else {
      console.log('Dispensary Provider Error: non-400');
      setDispensaryNotFound(true);
      setCurrentDispensaryId(DISPENSARY_NOT_AVAILABLE); 
      trackEvent(`dispensary_provider_error_${currentDispensaryId}`);
    }
    setLoading(false);  
  }, [currentDispensaryId, dispatch]);

  const setDispensaryId = (newDispensaryId) => {
    if (typeof newDispensaryId !== "undefined" && 
        newDispensaryId !== currentDispensaryId) {
      setCurrentDispensaryId(newDispensaryId);
    }
  }; 
  
  // Fetch Dispensary  
  React.useEffect(() => {
    const controller = new AbortController();
    if (!["undefined", DISPENSARY_NOT_AVAILABLE, dispensary?.id].includes(currentDispensaryId)) {
      setLoading(true);
      fetchDispensary(currentDispensaryId, dispensaryCallback, controller);
    }
    // cancel fetch on unmount
    return () => controller.abort();
  }, [currentDispensaryId, dispensary, dispensaryCallback]);

  return <DispensaryContext.Provider value={{
     dispensary,
     dispensaryNotFound,
     loading,
     setDispensaryId
    }}>
    {children}
  </DispensaryContext.Provider>
}

DispensaryProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object,PropTypes.array]).isRequired
}

export default DispensaryProvider;